import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import SkeletonTable from "../../components/table/SkeletonTable";
import toast from "react-hot-toast";
import moment from "moment";
import CryptoJS from "crypto-js";
import { Form, Input, Upload, Image, Select } from "antd";
import LoadableButton from "../../components/button/LoadableButton";
import UserAvatar from "../../components/common/UserAvatar";
import columns from "../../columns/License/columns";
import GlobalTooltip from "../../components/common/GlobalTooltip";
import ModalComponent from "../../components/global/modals/ModalComponent";
import Edit from "../../assets/Edit";
import Plus from "../../assets/Plus";
import LeftArrow from "../../assets/LeftArrow";
import { GetLicenseApi } from "../../api/request/dashboard";
import { deleteLicenseApi, EditLicenseApi } from "../../api/request/license";
import { GetPlanListApi } from "../../api/request/license";
import { AddLicenseApi } from "../../api/request/license";
import { GetCountryDetailsApi } from "../../api/request/countryDetail";
import ConfirmationModal from "../../components/global/modals/ConfirmationModal";
import Login from "../../assets/Login";
import { Cookies } from "react-cookie";
import AdminWiseEmployeeModal from "./AdminWiseEmployeeModal";
import UserRound from "../../assets/UserRound";
import UsersRound from "../../assets/UsersRound";

const { Option } = Select;

const License = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [currentView, setCurrentView] = useState(state?.status || "default");
  const [isLoadingLicense, setIsLoadingLicense] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [previewImage, setPreviewImage] = useState("");
  const [previewOpen, setPreviewOpen] = useState(false);
  const [planOptions, setPlanOptions] = useState([]);
  const [editingLicense, setEditingLicense] = useState(null);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [countryDetails, setCountryDetails] = useState([]);
  const [isLicenseDelete, setIsLicenseDelete] = useState(false);
  const [isDeleteLoading, setIsDeleteLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const initialValues = { serviceName: "" };
  const secretKey = process.env.REACT_APP_SECRET_KEY;

  const GetLicenseData = async () => {
    try {
      setIsLoadingLicense(true);
      const { data } = await GetLicenseApi();
      setData(
        data?.data?.map((item) => ({
          ...item,
          userDetails: <UserAvatar data={item} />,
          businessLogo: (
            <p
              className={`hover:underline ${
                item?.license?.logo
                  ? "text-blue-500 cursor-pointer"
                  : "cursor-not-allowed text-gray-400"
              }`}
              onClick={() => {
                if (item?.license?.logo) {
                  window.open(item.license.logo, "_blank");
                }
              }}
            >
              View
            </p>
          ),

          domainName: item?.license?.domain_name,
          url: (
            <div className="flex flex-col">
              <a
                href={item?.license?.admin_portal_url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${
                  item?.license?.admin_portal_url
                    ? ""
                    : "cursor-not-allowed text-gray-400"
                }`}
              >
                Backoffice
              </a>
              <a
                href={item?.license?.client_portal_url}
                target="_blank"
                rel="noopener noreferrer"
                className={`${
                  item?.license?.admin_portal_url
                    ? ""
                    : "cursor-not-allowed text-gray-400"
                }`}
              >
                Cabinet
              </a>
            </div>
          ),
          licenseName: item?.license?.license_name,
          created_at: item?.created_at
            ? moment(item?.created_at).format("lll")
            : "--",
          action: (
            <div className="flex items-center gap-2">
              <GlobalTooltip title="Edit License">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setEditingLicense(item);
                    setIsEditModalOpen(true);
                    form.setFieldsValue({
                      name: item?.first_name,
                      email: item?.email,
                      mobile_no: item?.mobile_no,
                      domain_name: item?.license?.domain_name,
                      license_name: item?.license?.license_name,
                      admin_portal_url: item?.license?.admin_portal_url,
                      client_portal_url: item?.license?.client_portal_url,
                      gst_no: item?.license?.gst_no,
                    });
                    if (item?.license?.logo) {
                      setFileList([
                        {
                          uid: "-1",
                          name: "logo.png",
                          status: "done",
                          url: item.license.logo,
                        },
                      ]);
                    } else {
                      setFileList([]);
                    }
                  }}
                >
                  <Edit />
                </button>
              </GlobalTooltip>
              <GlobalTooltip title="Client List">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    navigate(`/client_list/${item?.id}`, {
                      state: { adminData: item },
                    });
                  }}
                >
                  <UserRound className="size-5" />
                </button>
              </GlobalTooltip>
              <GlobalTooltip title="Employee List">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setSelectedEmployee(item); // <-- store clicked row data
                    setShowEmployeeModal(true); // <-- open modal
                  }}
                >
                  <UsersRound className="size-5" />
                </button>
              </GlobalTooltip>
              {/* <GlobalTooltip title="Delete License">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    setIsLicenseDelete(true);
                    setSelectedItem(item);
                  }}
                >
                  <Delete className="size-5" color="#000" />
                </button>
              </GlobalTooltip> */}
              <GlobalTooltip title="Login Admin">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleAdminLogin(item);
                  }}
                  className={`${
                    item?.license?.admin_portal_url ? "" : "cursor-not-allowed"
                  }`}
                >
                  <Login />
                </button>
              </GlobalTooltip>
            </div>
          ),
        }))
      );
    } catch (error) {
    } finally {
      setIsLoadingLicense(false);
    }
  };

  const handleAdminLogin = async (client) => {
    if (!client?.license?.admin_portal_url) return;
    const cookies = new Cookies();
    const { token } = cookies.getAll();
    const data = JSON.stringify({ token, AdminId: client?.id });
    const encrypted = CryptoJS.AES.encrypt(data, secretKey);
    const safeCiphertext = encrypted.toString();

    const redirectUrl = `${
      client?.license?.admin_portal_url
    }super_admin_login?token=${encodeURIComponent(safeCiphertext)}`;
    window.open(redirectUrl);
  };

  const deleteItemHandler = async () => {
    try {
      setIsDeleteLoading(true);
      const params = { id: selectedItem?.id };
      const { data } = await deleteLicenseApi(params);
      if (data?.status) {
        toast.success(data?.message);
        setData((prevLicense) =>
          prevLicense?.filter((item) => item?.id !== selectedItem?.id)
        );
        setIsLicenseDelete(false);
      }
    } catch (error) {
      if (error?.response?.data?.message)
        toast.error(error?.response?.data?.message);
    } finally {
      setIsDeleteLoading(false);
    }
  };

  const GetPlanList = async () => {
    try {
      const { data } = await GetPlanListApi();

      const options = data?.data?.map((plan) => ({
        label: plan.name,
        value: plan.id,
      }));

      setPlanOptions(options);
    } catch (error) {
      console.error("Error fetching plan list:", error);
    }
  };

  const handleAddLicense = async (values) => {
    try {
      setIsLoading(true);

      const formData = new FormData();
      const apiHeader = {
        headers: {
          Accept: "application/json",
          // "Content-Type": "multipart/form-data",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      formData.append("name", values.name);
      formData.append("email", values.email);
      formData.append("password", values.password);
      formData.append("mobile_no", values.mobile_no);
      formData.append("plan_id", values.plan_id);
      formData.append("domain_name", values.domain_name);
      formData.append("license_name", values.license_name);
      formData.append("admin_portal_url", values.admin_portal_url);
      formData.append("client_portal_url", values.client_portal_url);
      formData.append("gst_no", values.gst_no || "");

      if (values.logo?.length) {
        const file = values?.logo?.[0]?.originFileObj;
        if (file) {
          formData.append("logo", file);
        }
      }

      const { data } = await AddLicenseApi(formData, apiHeader);
      form.resetFields();
      setFileList([]);
      toast.success(data?.message);
      setCurrentView("default");
      GetLicenseData();
    } catch (error) {
      console.error("Error creating license:", error);
      toast.error(error?.response?.data?.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handleEditLicense = async (values) => {
    try {
      setIsLoading(true);

      const formData = new FormData();
      const apiHeader = {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/x-www-form-urlencoded",
        },
      };
      formData.append("name", values.name);
      formData.append("license_id", editingLicense?.license?.id);
      formData.append("email", values.email);
      formData.append("mobile_no", values.mobile_no);
      formData.append("domain_name", values.domain_name);
      formData.append("license_name", values.license_name);
      formData.append("admin_portal_url", values.admin_portal_url);
      formData.append("client_portal_url", values.client_portal_url);
      formData.append("gst_no", values.gst_no || "");

      if (values.logo?.length && values.logo[0]?.originFileObj) {
        formData.append("logo", values.logo[0].originFileObj);
      }

      const response = await EditLicenseApi(formData, apiHeader);
      toast.success(response?.data?.message || "License updated successfully!");
      form.resetFields();
      setFileList([]);
      setEditingLicense(null);
      setIsEditModalOpen(false);
      setCurrentView("default");
      GetLicenseData();
    } catch (error) {
      console.error("Error editing license:", error);
      toast.error(
        error?.response?.data?.message || "Failed to update license!"
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
    form.setFieldsValue({ logo: newFileList });
    if (!newFileList?.length) {
      form.setFieldsValue({ logo: [] });
    }
  };

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
  };

  const UploadButton = (
    <button type="button" className="flex flex-col items-center gap-2">
      <div className="size-7">
        <img src="/assets/icons/upload.svg" alt="icon" />
      </div>
      Upload
    </button>
  );

  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const getCountryDetails = async () => {
    try {
      const { data } = await GetCountryDetailsApi();
      if (data?.status) {
        setCountryDetails(data?.data);
      }
    } catch (error) {
      if (error?.response?.data?.message) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  useEffect(() => {
    GetLicenseData();
    GetPlanList();
    getCountryDetails();
  }, []);

  useEffect(() => {
    if (state?.status === "add") {
      setCurrentView("add");
    }
  }, [state]);

  useEffect(() => {
    if (currentView === "add") {
      form.resetFields();
      setFileList([]);
    }
  }, [currentView, form]);

  return (
    <>
      {currentView === "default" ? (
        // ---------- Table View ----------
        <div className="border bg-white rounded-xl py-3">
          <div className="flex items-center justify-between sm:px-4 max-sm:px-2 mb-1">
            <h2 className="font-semibold text-xl">Manage License</h2>
            <button
              className="flex items-center gap-2 m-2 px-4 py-2 bg-secondary text-white rounded-md max-sm:px-1 max-sm:py-1"
              onClick={() => setCurrentView("add")}
            >
              <Plus className="w-5 h-5" />
              <span className="max-sm:text-xs">Add License</span>
            </button>
          </div>
          <SkeletonTable
            columns={columns}
            data={data}
            isLoading={isLoadingLicense}
            pagination={true}
          />
        </div>
      ) : (
        // ---------- Add License Page ----------
        <div className="border bg-White rounded-xl p-6">
          <div className="flex items-center gap-3 mb-6">
            <div
              className="cursor-pointer"
              onClick={() => {
                form.resetFields();
                setFileList([]);
                setCurrentView("default");
              }}
            >
              <LeftArrow />
            </div>
            <p className="title">Add License</p>
          </div>

          <Form
            autoComplete="off"
            form={form}
            initialValues={initialValues}
            layout="vertical"
            onFinish={handleAddLicense}
          >
            <div className="grid grid-cols-2 gap-4 gap-y-1">
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "Please enter name!" }]}
              >
                <Input placeholder="Enter name" size="large" />
              </Form.Item>

              <Form.Item
                label="Email"
                name="email"
                rules={[{ required: true, message: "Please enter email!" }]}
              >
                <Input placeholder="Enter email" size="large" />
              </Form.Item>

              <Form.Item
                label="Password"
                name="password"
                rules={[{ required: true, message: "Please enter password!" }]}
              >
                <Input.Password placeholder="Enter password" size="large" />
              </Form.Item>

              <div className="flex sm:flex-row flex-col sm:gap-4 !m-0">
                <Form.Item
                  label={<p className="font-semibold">Country code</p>}
                  name="country_code"
                  rules={[{ required: true, message: "Please select country" }]}
                >
                  <Select placeholder="Country code" size="large">
                    {countryDetails.map((countryData, index) => (
                      <Option key={index} value={countryData?.phonecode}>
                        <div className="flex items-center space-x-3">
                          <div className="rounded-full bg-secondaryLight w-9 h-9 flex justify-center items-center">
                            <img
                              src={countryData?.image}
                              alt="flag"
                              className="w-7 h-7 object-contain rounded-full"
                            />
                          </div>
                          <span className="text-base">
                            + {countryData?.phonecode}
                          </span>
                        </div>
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item
                  label={<p className="font-semibold">Mobile No.</p>}
                  name="mobile_no"
                  rules={[
                    { required: true, message: "Please input mobile number!" },
                    {
                      pattern: /^\d{10}$/,
                      message: "Please enter valid 10-digit mobile number.",
                    },
                  ]}
                  className="w-full"
                >
                  <Input
                    size="large"
                    type="tel"
                    maxLength={10}
                    placeholder="Mobile No."
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Item>
              </div>

              <Form.Item
                label="Plan"
                name="plan_id"
                rules={[{ required: true, message: "Please select a plan!" }]}
              >
                <Select
                  placeholder="Select a plan"
                  size="large"
                  options={planOptions}
                  loading={!planOptions.length}
                />
              </Form.Item>

              <Form.Item
                label="Domain Name"
                name="domain_name"
                rules={[
                  { required: true, message: "Please enter domain name!" },
                ]}
              >
                <Input placeholder="Enter domain name" size="large" />
              </Form.Item>

              <Form.Item
                label="License Name"
                name="license_name"
                rules={[
                  { required: true, message: "Please enter license name!" },
                ]}
              >
                <Input placeholder="Enter license name" size="large" />
              </Form.Item>

              <Form.Item
                label="Admin Portal URL"
                name="admin_portal_url"
                rules={[
                  { required: true, message: "Please enter admin portal URL!" },
                ]}
              >
                <Input placeholder="Enter admin portal URL" size="large" />
              </Form.Item>

              <Form.Item
                label="Client Portal URL"
                name="client_portal_url"
                rules={[
                  {
                    required: true,
                    message: "Please enter client portal URL!",
                  },
                ]}
              >
                <Input placeholder="Enter client portal URL" size="large" />
              </Form.Item>

              <Form.Item label="GST No." name="gst_no">
                <Input placeholder="Enter GST No." size="large" />
              </Form.Item>

              <div className="col-span-2">
                <Form.Item name="logo" label="Business Logo">
                  <Upload
                    beforeUpload={() => false}
                    multiple
                    listType="picture-card"
                    fileList={fileList}
                    onPreview={handlePreview}
                    onChange={handleChange}
                  >
                    {fileList.length >= 1 ? null : UploadButton}
                  </Upload>
                </Form.Item>

                {previewImage && (
                  <Image
                    wrapperStyle={{ display: "none" }}
                    preview={{
                      visible: previewOpen,
                      onVisibleChange: (visible) => setPreviewOpen(visible),
                      afterOpenChange: (visible) =>
                        !visible && setPreviewImage(""),
                    }}
                    src={previewImage}
                  />
                )}
              </div>
            </div>

            <div className="flex justify-center">
              <LoadableButton
                className="btn-primary"
                type="submit"
                lable="Confirm"
                loadingLable="Creating License..."
                isLoading={isLoading}
              />
            </div>
          </Form>
        </div>
      )}

      {/* ---------- Edit License Modal ---------- */}
      <ModalComponent
        isOpen={isEditModalOpen}
        setIsOpen={setIsEditModalOpen}
        title="Edit License"
        width={800}
      >
        <Form
          autoComplete="off"
          form={form}
          layout="vertical"
          onFinish={handleEditLicense}
        >
          <div className="grid grid-cols-2 gap-4 gap-y-1">
            <Form.Item
              label="Domain Name"
              name="domain_name"
              rules={[{ required: true, message: "Please enter domain name!" }]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="License Name"
              name="license_name"
              rules={[
                { required: true, message: "Please enter license name!" },
              ]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Admin Portal URL"
              name="admin_portal_url"
              rules={[
                { required: true, message: "Please enter admin portal URL!" },
              ]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item
              label="Client Portal URL"
              name="client_portal_url"
              rules={[
                { required: true, message: "Please enter client portal URL!" },
              ]}
            >
              <Input size="large" />
            </Form.Item>

            <Form.Item label="GST No." name="gst_no">
              <Input size="large" />
            </Form.Item>

            <div className="col-span-2">
              <Form.Item name="logo" label="Business Logo">
                <Upload
                  beforeUpload={() => false}
                  multiple
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={handlePreview}
                  onChange={handleChange}
                >
                  {fileList.length >= 1 ? null : UploadButton}
                </Upload>
              </Form.Item>

              {previewImage && (
                <Image
                  wrapperStyle={{ display: "none" }}
                  preview={{
                    visible: previewOpen,
                    onVisibleChange: (visible) => setPreviewOpen(visible),
                    afterOpenChange: (visible) =>
                      !visible && setPreviewImage(""),
                  }}
                  src={previewImage}
                />
              )}
            </div>
          </div>

          <div className="flex justify-center">
            <LoadableButton
              className="btn-primary"
              type="submit"
              lable="Update"
              loadingLable="Updating License..."
              isLoading={isLoading}
            />
          </div>
        </Form>
      </ModalComponent>

      {/* ---------- Delete License Modal ---------- */}
      <ConfirmationModal
        isOpen={isLicenseDelete}
        setIsOpen={setIsLicenseDelete}
        message={`Are you sure you want to permanently delete this License?`}
        onConfirm={deleteItemHandler}
        isLoading={isDeleteLoading}
        loadingLabel={`Deleting License...`}
      />

      <AdminWiseEmployeeModal
        isOpen={showEmployeeModal}
        setIsOpen={setShowEmployeeModal}
        selectedAdmin={selectedEmployee}
      />
    </>
  );
};

export default License;
